import { api } from './apiInstances';

// UPDATE UBICATION MONTHLY DETAILS V2
export const putUbicationMonthlyDetailService = async (id, values) => {
  const result = await api.put(`/V1/SolicitudesServicioMensualizada/${id}/pozos`, values);

  return result.data;
};

export const putUbicationMonthlyOyMDetailService = async (id, values) => {
  const result = await api.put(
    `/v1/SolicitudesServicioMensualizada/ubicaciones/${id}/detalleOyM`,
    values
  );

  return result.data;
};

// Solicitud de servicio mensualizaada
export const getExistingUbicationsOfSSMonthly = async (id) => {
  const result = await api.get(
    `/v1/SolicitudesServicioMensualizada/${id}/ubicacionesExistentes?finalizadas=false`
  );

  return result.data;
};

export const getlocationsMonthly = async (id, body) => {
  const result = await api.post(
    `v1/SolicitudesServicioMensualizada/${id}/ubicacionesFiltradas`,
    body
  );

  return result.data;
};

export const getPosLinesMonthly = async (id, body) => {
  const result = await api.post(`v1/SolicitudesServicioMensualizada/${id}/lineasFiltradas`, body);

  return result.data;
};

export const getFinishedServiceAvailability = async (ubicationId) => {
  const result = await api.get(
    `v1/SolicitudesServicioMensualizada/ubicacion/${ubicationId}/habilitacionFinalizacion`
  );

  return result.data;
};

export const setMonthlyFinishedService = async (serviceId, ubicationId) => {
  const result = await api.patch(
    `v1/SolicitudesServicioMensualizada/${serviceId}/ubicacion/${ubicationId}/finalizacion`
  );

  return result.data;
};

// Cabecera
export const getDetailsMonthlyHeader = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicioMensualizada/${id}/cabecera`);

  return result.data;
};

// GET of MonthlyApproversTab
export const getMonthlyApprovers = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicioMensualizada/${id}/aprobadores`);

  return result.data;
};

// Delete approver
export const deleteMonthlyApprovers = async (approverId) => {
  const result = await api.delete(`/v1/SolicitudesServicioMensualizada/aprobador/${approverId}`);

  return result.data;
};

// Add approver
export const postMonthlyApprovers = async (body) => {
  const result = await api.post(`/v1/SolicitudesServicioMensualizada/aprobador`, body);

  return result.data;
};

// PESTAÑA MENSAJES
export const getMessagesMonthly = async (id, skip, pageSize = 10) => {
  const result = await api.get(
    `/v1/SolicitudesServicioMensualizada/${id}/mensajes?Skip=${skip}&PageSize=${pageSize}`
  );

  return result.data;
};

export const sendMessageMonthly = async (id, param) => {
  const result = await api.post(`/v1/SolicitudesServicioMensualizada/${id}/nuevoMensaje`, param);

  return result.data;
};
// Cancel MSDS
export const putCancelMonthly = async (id) => {
  const result = await api.put(`/v1/SolicitudesServicioMensualizada/${id}/cancelacion`);

  return result.data;
};

// Finalize MSDS
export const putFinalizeServiceMonthly = async (id, body) => {
  const result = await api.put(`/v1/SolicitudesServicioMensualizada/${id}/finalizacion`, body);

  return result.data;
};

export default getDetailsMonthlyHeader;
//  Comunicar A-Mensualizadas

//  destinatario comunicar a y destinatario copia a
export const getMonthlyCommunicateTo = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicioMensualizada/${id}/destinatarios`);

  return result.data;
};
//  PUT Destinatarios-copia a
export const putMonthlyCommunicateTo = async (params, id) => {
  const result = await api.put(`/v1/SolicitudesServicioMensualizada/${id}/destinatarios`, params);

  return result.data;
};

// Historial-Mensualizadas
export const getMonthlyHistory = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicioMensualizada/${id}/historial`);

  return result.data;
};

// Parte de Trabajo Mensualizada
export const getMonthlyUbicationDetail = async ({ id, isOyM = false }) => {
  const monthlyUbicationDetail = isOyM
    ? `/v1/SolicitudesServicioMensualizada/ubicaciones/${id}/detalleOyM`
    : // : `/v1/SolicitudesServicioMensualizada/ubicaciones/${id}/detalle`;
      `/v2/SolicitudesServicioMensualizada/ubicaciones/${id}/detalle`;
  const result = await api.get(monthlyUbicationDetail);

  return result.data;
};

export const updateMonthlyUbicationDetail = async (id, params) => {
  const result = await api.put(
    `/v1/SolicitudesServicioMensualizada/ubicaciones/${id}/detalle`,
    params
  );

  return result.data;
};

export const getMonthlyBusinessUnits = async (id) => {
  const result = await api.get(`v1/SolicitudesServicioMensualizada/${id}/unidadesNegocio`);

  return result.data;
};

export const getMonthlyOperations = async (id) => {
  const result = await api.get(`v1/SolicitudesServicioMensualizada/${id}/operaciones`);

  return result.data;
};

export const postCreateLocation = async (id, params) => {
  const result = await api.post(`/v1/SolicitudesServicioMensualizada/${id}/ubicaciones`, params);

  return result.data;
};

// GET lines by ubication
export const getMonthlyLinesByUbication = async ({
  id,
  date,
  idEquipment,
  validityDate,
  forceWindow
}) => {
  const url = `/v1/SolicitudesServicioMensualizada/ubicaciones/${id}/posicionesLineas`;
  const uriParameters = new URLSearchParams();

  if (date) {
    uriParameters.append('fecha', date);
  }

  if (idEquipment) {
    uriParameters.append('idEquipo', idEquipment);
  }

  if (validityDate) {
    uriParameters.append('fechaVigencia', validityDate.split('T')[0]);
  }

  uriParameters.append('forzarVentanaNotificacion', forceWindow === true);

  const newURL = url.concat(`?${uriParameters.toString()}`);
  const result = await api.get(newURL);

  return result.data;
};

export const getMonthlyLinesByLocation = async (id, idUbicacion, body) => {
  const url = `/v1/SolicitudesServicioMensualizada/${id}/ubicaciones/${idUbicacion}/detalle`;

  const result = await api.post(url, body);

  return result.data;
};

// GET calendar colorin
export const getColorQuantityNotifiedCalendar = async ({ id, date }) => {
  const url = `/v1/SolicitudesServicioMensualizada/ubicaciones/${id}/posicionesLineas/calendarioCantidades`;

  const uriParameters = new URLSearchParams();

  if (date) {
    uriParameters.append('fecha', date);
  }

  const newURL = url.concat(`?${uriParameters.toString()}`);
  const result = await api.get(newURL);

  return result.data;
};

export const getMonthlyUbicationByPositionsLines = async (
  id,
  date,
  goToFirstDay,
  goToLastDay,
  validityDate,
  forceWindow
) => {
  const url = `/v1/SolicitudesServicioMensualizada/posicionesLineas/${id}/ubicaciones`;
  const uriParameters = new URLSearchParams();

  if (date) {
    uriParameters.append('fecha', date);
  }
  if (goToFirstDay) {
    uriParameters.append('primerDiaLineaPendiente', true);
  }

  if (goToLastDay) {
    uriParameters.append('primerDiaLineaPendiente', false);
  }

  if (validityDate) {
    uriParameters.append('fechaVigencia', validityDate.split('T')[0]);
  }

  uriParameters.append('forzarVentanaNotificacion', forceWindow === true);

  const newURL = url.concat(`?${uriParameters.toString()}`);
  const result = await api.get(newURL);

  return result.data;
};

export const getMonthlyLocationByPositionsLines = async (id, idPosicionLinea, body) => {
  const url = `/v1/SolicitudesServicioMensualizada/${id}/lineas/${idPosicionLinea}/detalle`;

  const result = await api.post(url, body);

  return result.data;
};

export const getPtdByPositionAndLineService = async (id, positionNumber, lineNumber, date) => {
  const result = await api.get(
    `/v1/SolicitudesServicioMensualizada/${id}/posicionesLineas/calendarioCantidades?numeroPosicion=${positionNumber}&numeroLinea=${lineNumber}&fecha=${date}`
  );

  return result.data;
};

// GET Total of line
export const getMonthlyTotalOfLine = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicioMensualizada/${id}/total`);

  return result.data;
};

export const getMonthlyLinesByUbicationCS = async ({
  id,
  idEquipment,
  validityDate,
  forceWindow
}) => {
  const url = `/v1/SolicitudesServicioMensualizada/${id}/ubicaciones/partesTrabajoDiario`;
  const uriParameters = new URLSearchParams();

  if (idEquipment) {
    uriParameters.append('idEquipo', idEquipment);
  }

  if (validityDate) {
    uriParameters.append('fechaVigencia', validityDate.split('T')[0]);
  }

  uriParameters.append('forzarVentanaNotificacion', forceWindow === true);

  const newURL = url.concat(`?${uriParameters.toString()}`);
  const result = await api.get(newURL);

  return result.data;
};

export const getMonthlyLinesByUbicationSimplifiedC = async (id, body) => {
  const url = `v1/SolicitudesServicioMensualizada/${id}/ubicaciones/cargaSimplificada`;

  const res = await api.post(url, body);

  return res.data;
};

export const getMonthlyLinesByPositionLineCS = async (id, validityDate, forceWindow) => {
  const url = `/v1/SolicitudesServicioMensualizada/${id}/lineas/partesTrabajoDiario`;
  const uriParameters = new URLSearchParams();

  if (validityDate) {
    uriParameters.append('fechaVigencia', validityDate.split('T')[0]);
  }

  uriParameters.append('forzarVentanaNotificacion', forceWindow === true);

  const newURL = url.concat(`?${uriParameters.toString()}`);
  const result = await api.get(newURL);

  return result.data;
};

export const getMonthlyLinesByPositionLineSimplifiedC = async (id, body) => {
  const url = `v1/SolicitudesServicioMensualizada/${id}/lineas/cargaSimplificada`;

  const res = await api.post(url, body);

  return res.data;
};

// Download work report MDSD
export const downloadWorkReportMSDS = async (id) => {
  try {
    const result = await api.get(
      `/v1/SolicitudesServicioMensualizada/${id}/partesTrabajoDiario/descargaExcel`,
      {
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        responseType: 'blob'
      }
    );

    const url = window.URL.createObjectURL(new Blob([result.data]));
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', `parteDeTrabajoN°${id}.xlsx`);
    document.body.appendChild(link);
    link.click();

    return {
      success: true,
      data: result
    };
  } catch (err) {
    const mensaje = err?.message || err?.errorMessage || err?.result;

    throw new Error(mensaje);
  }
};

// POST Position and lines to Ubications
export const postPosLineToUbications = async (id, body) => {
  const result = await api.post(
    `/v1/SolicitudesServicioMensualizada/${id}/ubicaciones/lineas`,
    body
  );

  return result.data;
};

// POST ubications to Position-Lines
export const postUbicationToPosLine = async (id, body) => {
  const result = await api.post(
    `/v1/SolicitudesServicioMensualizada/${id}/lineas/ubicaciones`,
    body
  );

  return result.data;
};

// Archivos -Ubicaciones existentes con líneas
export const getLocationFile = async (id, idLinea) => {
  const result = await api.get(
    `/v1/SolicitudesServicioMensualizada/${id}/ubicacionesExistentesConLineas?idLinea=${idLinea}`
  );

  return result.data;
};

// Archivos-Fechas para ubicación y líneas
export const getDateFile = async (idLinea, idUbicacion) => {
  const baseUrlService = '/v1/SolicitudesServicioMensualizada';
  const result = await api.get(
    `${baseUrlService}/ubicaciones/${idUbicacion}/lineas/${idLinea}/partesTrabajoDiario/fechas`
  );

  return result.data;
};

// GET teams of MSDS
export const getMonthlyTeams = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicioMensualizada/${id}/equipos`);

  return result.data;
};

// GET  Actions Components to InspectorExpertReviewModal Mensualizada
export const getActionComponentsMonthly = async (idParteTrabajoDiario) => {
  const baseUrlService = '/v1/SolicitudesServicioMensualizada';
  const result = await api.get(`${baseUrlService}/rectificarCantidad/${idParteTrabajoDiario}`);

  return result.data;
};

// POST - To get pending authorization lines
export const postPendingAuthorizationMonthly = async (body) => {
  const result = await api.post('/v2/SolicitudesServicioMensualizada/pendienteDeAutorizar', body);

  return result.data;
};

// POST - To get pending authorization ubications
export const getPendingAuthorizationMonthlyUbications = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicioMensualizada/${id}/Ubicaciones`);

  return result.data;
};
// POST - To get calendar data
export const postCalendarData = async (body) => {
  const result = await api.post(
    '/v1/SolicitudesServicioMensualizada/calendarioDeCostosPorUbicacion',
    body
  );

  return result.data;
};

// Details Events

export const getDetailsEvents = async ({ idSolicitudMensualizada, idUbicacion }) => {
  const result = await api.get(
    `v1/SolicitudesServicioMensualizada/${idSolicitudMensualizada}/evento/${idUbicacion}`
  );

  return result.data;
};

export const getPositionMSDSDetail = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicioMensualizada/${id}/posiciones`);

  return result.data;
};

export const getLinesMSDSDetail = async (id, positionId) => {
  const result = await api.get(
    `/v1/SolicitudesServicioMensualizada/${id}/posiciones/${positionId}/lineas`
  );

  return result.data;
};

export const getEventsMSDSDetail = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicioMensualizada/${id}/eventos`);

  return result.data;
};

export const getTypeOfLocationMSDSDetail = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicioMensualizada/${id}/tipoUbicaciones`);

  return result.data;
};

export const getLocationsMSDSDetail = async (id) => {
  const result = await api.get(
    `v1/SolicitudesServicioMensualizada/${id}/ubicacionesExistentes?finalizadas=true`
  );

  return result.data;
};

export const getTowerEquipmentMSDSDetail = async (id) => {
  const result = await api.get(`v1/SolicitudesServicioMensualizada/${id}/equiposDeTorre`);

  return result.data;
};

export const getFilterPTMSDSDetail = async (id) => {
  const result = await api.get(`v1/SolicitudesServicioMensualizada/${id}/filtros`);

  const parsedbody = result?.data?.filtros
    ? JSON.parse(result.data?.filtros)
    : {
        equiposIds: [],
        eventosIds: [],
        tipoUbicacionesIds: [],
        ubicacionesIds: [],
        posicionesLineas: []
      };

  return parsedbody;
};

export const postFilterPTMSDSDetail = async (id, body) => {
  const requestBody = JSON.stringify(body);
  const nestedRequestBody = JSON.stringify(requestBody);

  const result = await api.post(
    `v1/SolicitudesServicioMensualizada/${id}/filtros`,
    nestedRequestBody
  );

  return result.data;
};
